import { useMemo } from 'react';
import { useAccount } from 'hooks/use-account';
import { useTranslation } from 'hooks/use-translation';
export var ProjectPlanFilterTypes = /*#__PURE__*/ function(ProjectPlanFilterTypes) {
    ProjectPlanFilterTypes["All"] = "all";
    ProjectPlanFilterTypes["IncompleteTasks"] = "tasks:incomplete";
    ProjectPlanFilterTypes["CompletedTasks"] = "tasks:complete";
    ProjectPlanFilterTypes["Responsibility"] = "responsible";
    return ProjectPlanFilterTypes;
}({});
export const useProjectPlanFilter = ({ customer, partners })=>{
    const { company } = useAccount();
    const allText = useTranslation('all');
    const allTasksText = useTranslation('all_tasks');
    const incompleteTasksText = useTranslation('projects.filters.incomplete_tasks');
    const completedTasksText = useTranslation('projects.filters.completed_tasks');
    const secondaryFilters = useMemo(()=>[
            {
                label: allText,
                value: "all",
                id: "all",
                filter () {
                    return true;
                }
            },
            {
                id: "responsible",
                label: company.companyName,
                value: company.companyId,
                companyLogoUrl: company.companyLogoUrl,
                filter (task, selected) {
                    var _task_responsible;
                    return ((_task_responsible = task.responsible) !== null && _task_responsible !== void 0 ? _task_responsible : []).map((owner)=>owner.companyId).includes(selected.value);
                }
            },
            ...customer != null ? [
                {
                    id: "responsible",
                    label: customer === null || customer === void 0 ? void 0 : customer.companyName,
                    value: customer === null || customer === void 0 ? void 0 : customer.companyId,
                    companyLogoUrl: customer === null || customer === void 0 ? void 0 : customer.companyLogoUrl,
                    filter (task, selected) {
                        var _task_responsible;
                        return ((_task_responsible = task.responsible) !== null && _task_responsible !== void 0 ? _task_responsible : []).map((owner)=>owner.companyId).includes(selected.value);
                    }
                }
            ] : []
        ].concat((partners !== null && partners !== void 0 ? partners : []).map((partner)=>({
                id: "responsible",
                label: partner.companyName,
                value: partner.companyId,
                companyLogoUrl: partner.companyLogoUrl,
                filter (task, selected) {
                    var _task_responsible;
                    return ((_task_responsible = task.responsible) !== null && _task_responsible !== void 0 ? _task_responsible : []).map((owner)=>owner.companyId).includes(selected.value);
                }
            }))), [
        allText,
        company.companyId,
        company.companyLogoUrl,
        company.companyName,
        customer,
        partners
    ]);
    const filters = useMemo(()=>({
            primary: [
                {
                    label: allTasksText,
                    id: "all",
                    value: "all",
                    filter () {
                        return true;
                    }
                },
                {
                    label: incompleteTasksText,
                    value: "tasks:incomplete",
                    id: "tasks:incomplete",
                    filter (task) {
                        return !task.completedAt;
                    }
                },
                {
                    label: completedTasksText,
                    value: "tasks:complete",
                    id: "tasks:complete",
                    filter (task) {
                        return !!task.completedAt;
                    }
                }
            ],
            secondary: secondaryFilters
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        secondaryFilters
    ]);
    const defaultFilter = useMemo(()=>({
            primary: filters.primary.find((filter)=>filter.id === "all"),
            secondary: filters.secondary.find((filter)=>filter.id === "all")
        }), [
        filters
    ]);
    return [
        filters,
        defaultFilter
    ];
};
